const getOrderStatus = (bookingInfo) => {
    if (bookingInfo?.summary?.has_customer_info !== undefined) {
        return bookingInfo.summary.has_customer_info ? 'Confirmed' : 'Incomplete';
    }
    if (bookingInfo?.booking_status?.status) {
        const status = bookingInfo.booking_status.status;
        let readableStatus = status.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
        // Normalize 'Confirmed' to 'Booking Confirmed' to handle backend data inconsistency
        if (readableStatus === 'Confirmed') {
            return 'Booking Confirmed';
        }
        return readableStatus;
    }
    return 'Pending';
};

/**
 * Label for cart_data.full_cart.items — matches BookingTab (name + optional model).
 * Confirmed bookings often populate `name` while `model` is empty; using only `model` left the column blank.
 */
const formatCartItemLabel = (item) => {
    if (!item) return '';
    const name = typeof item.name === 'string' ? item.name.trim() : '';
    const model = typeof item.model === 'string' ? item.model.trim() : '';
    if (name && model) return `${name} (${model})`;
    if (name) return name;
    if (model) return model;
    if (typeof item.type === 'string' && item.type.trim()) {
        return item.type.replace(/_/g, ' ');
    }
    return '';
};

/** Label for legacy booking_info.equipment_requested — matches BookingTab */
const formatLegacyEquipmentLabel = (equipment) => {
    if (!equipment) return '';
    const type = typeof equipment.type === 'string' ? equipment.type.trim() : '';
    const model = typeof equipment.model === 'string' ? equipment.model.trim() : '';
    if (type && model) return `${type} (${model})`;
    if (type) return type;
    if (model) return model;
    const name = typeof equipment.name === 'string' ? equipment.name.trim() : '';
    return name || '';
};

const getEquipmentList = (bookingInfo) => {
    if (bookingInfo?.full_cart?.items?.length > 0) {
        const labels = bookingInfo.full_cart.items.map(formatCartItemLabel).filter(Boolean);
        if (labels.length > 0) {
            return labels.join(', ');
        }
    }
    if (bookingInfo?.equipment_requested?.length > 0) {
        const labels = bookingInfo.equipment_requested.map(formatLegacyEquipmentLabel).filter(Boolean);
        if (labels.length > 0) {
            return labels.join(', ');
        }
    }
    return 'No Equipment';
};

export { getOrderStatus, getEquipmentList }; 